import { CustomerType } from "@/modules/space/constants/customerType"

export function customerTypeNavVisibility(
  customerType: number | null | undefined,
): { consultants: boolean; resources: boolean; assignments: boolean } {
  if (customerType === CustomerType.B2B) {
    return { consultants: true, resources: false, assignments: false }
  }

  if (
    customerType === CustomerType.RFQReceiver ||
    customerType === CustomerType.RFQSender ||
    customerType === CustomerType.RFQSenderReceiver
  ) {
    return { consultants: false, resources: true, assignments: true }
  }

  return { consultants: false, resources: false, assignments: false }
}
